import { NavLink } from 'react-router';
import { canOfferInstall, promptInstall, useInstallState } from '../lib/installPrompt';

const ITEMS = [
  { to: '/settings/profile', label: 'Profile' },
  { to: '/settings/household', label: 'Household' },
  { to: '/settings/schedule', label: 'Meal times & schedule' },
  { to: '/settings/places', label: 'Meal places' },
  { to: '/settings/devices', label: 'Devices' },
  { to: '/settings/passkeys', label: 'Passkeys' },
] as const;

export function SettingsNav() {
  const installState = useInstallState();
  return (
    <nav aria-label="Settings" className="-mx-4 mb-5 overflow-x-auto px-4 pb-1">
      <ul className="flex gap-2">
        {ITEMS.map((i) => (
          <li key={i.to}>
            <NavLink
              to={i.to}
              className={({ isActive }) =>
                `inline-flex min-h-11 items-center rounded-full border px-4 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-brand bg-brand text-white shadow-sm'
                    : 'border-line bg-surface text-ink hover:bg-brand-soft hover:text-brand'
                }`
              }
            >
              {i.label}
            </NavLink>
          </li>
        ))}
        {canOfferInstall(installState) ? (
          <li>
            <button
              type="button"
              onClick={() => void promptInstall()}
              className="inline-flex min-h-11 items-center rounded-full border border-dashed border-line bg-surface px-4 text-sm font-medium whitespace-nowrap text-muted transition-colors hover:bg-brand-soft hover:text-brand"
            >
              Install app
            </button>
          </li>
        ) : null}
      </ul>
    </nav>
  );
}
